import { Box, SxProps, useTheme } from '@mui/material';
import React from 'react';

interface IProps {
  sx?: SxProps;
  children: React.ReactNode;
}

export const PageHeader: React.FC<IProps> = ({ sx, children }) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        width: '100%',
        position: 'relative',
        padding: '30px 70px 24px 70px',
        display: 'flex',

        [`@media (min-width: 1366px)`]: {
          padding: '30px 30px 24px 30px',
        },
        [`@media (max-width: 1366px)`]: {
          padding: '20px 30px 24px 30px',
        },
        [theme.breakpoints.down('md')]: {
          paddingLeft: '20px',
          paddingRight: '20px',
          flexDirection: 'column',
          alignItems: 'flex-start',
        },
        [theme.breakpoints.down('xs')]: {
          padding: '15px 10px',
          paddingBottom: 0,
          marginBottom: 0,
        },

        ...sx,
      }}
    >
      {children}
    </Box>
  );
};
